import {IAutoOrderExpirationSettings} from './ao-order-expiration-settings.interface';

//#region DEFAULT _DEFAULT_AUTO_ORDER_ORDER_EXPIRATION_SETTINGS
export const _DEFAULT_AUTO_ORDER_ORDER_EXPIRATION_SETTINGS: Readonly<IAutoOrderExpirationSettings> = {
  isAgeLimitEnabled: true,
  orderAgeLimitMS: 604800000,
} as const;

//#endregion